/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers, lifecycle, withState } from 'recompose'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { withRouter } from 'react-router-dom'
import _get from 'lodash/get'
import { analytics } from 'services/Analytics'
import { EMPTY_OBJECT } from 'constants/frozenObjects'
import { ALERTS } from 'constants/alerts'
import { ERROR_CODES } from 'constants/errors'
import { withLocalization } from 'hocs/localization'
import { onAcceptTerms } from 'redux-app/actionCreators/subscription'
import { getTempSubscriptionTerms } from 'api/client/actions/subscriptions'
import { getUserDetails } from 'redux-app/selectors/user'
import { getSubscriptionPlans } from 'redux-app/selectors/subscription'
import { createAlert, onShowError } from 'redux-app/modules/alerts'
import { getErrorCodes } from 'utils/error'
import Terms from './Terms'

export default compose(
  withLocalization('profile.terms'),
  connect(
    state => {
      const userDetails = getUserDetails(state) || EMPTY_OBJECT
      const plans = getSubscriptionPlans(state) || EMPTY_OBJECT
      const userSubscriptionId = _get(userDetails, ['subscription', 'planId'])

      return {
        plan: plans.find(plan => plan.id === userSubscriptionId),
      }
    },
    {
      onAcceptTerms,
      getTempSubscriptionTerms,
      createAlert,
      onShowError,
    },
  ),
  withHandlers({
    acceptTerms: ({ onAcceptTerms }) => ({ customerSignature }) => {
      return onAcceptTerms({ customerSignature })
        .catch(error => {
          analytics.showReviewTermsError({ errorCodes: getErrorCodes(error) })
        })
    },
  }),
  reduxForm({
    form: 'acceptTerms',
  }),
  withState('data', 'setData', null),
  withState('isLoading', 'setLoadingStatus', true),
  lifecycle<any, any>({
    componentDidMount () {
      window.scrollTo(0, 0)
      analytics.openCreateReviewTermsPage()
      this.props.getTempSubscriptionTerms()
        .then(({ value: { result } }) => {
          this.props.setData(result.fields)
          this.props.setLoadingStatus(false)
        })
        .catch(error => {
          const errorCodes = getErrorCodes(error)
          if (errorCodes.includes(ERROR_CODES.sabrixNotAvailable)) {
            this.props.createAlert({ name: ALERTS.error })
            return
          }
          this.props.setLoadingStatus(false)
          this.props.onShowError(error)
        })
    },
  }),
  withRouter,
)(Terms)
